import { useState } from 'react';
import { AgCharts } from 'ag-charts-react';
import { OVMSUsageChartLogic } from './OVMSUsageChart';
import './OVMSUsageChart.scss';
import {
    ClientSideRowModelModule,
    ModuleRegistry,
} from 'ag-grid-enterprise';
import { Modal, Button, Spin } from 'antd';
import { ExpandAltOutlined } from '@ant-design/icons';
import LoadingOrbitalSpinner from '../LoadingOrbitalSpinner/LoadingOrbitalSpinner';

ModuleRegistry.registerModules([ClientSideRowModelModule]);

function OVMSUsageChart({ startAndEndUnixDatesParams }) {
    const { chartConfig, loading } = OVMSUsageChartLogic(startAndEndUnixDatesParams);
    const [modalOpen, setModalOpen] = useState(false);

    return (
        <Spin spinning={loading} indicator={<LoadingOrbitalSpinner />}>
            <div className='ovms-usage-chart'>
                <div className='ovms-usage-chart-wrapper'>
                    <Button
                        className='ovms-usage-chart-expand-btn'
                        type='text'
                        size='small'
                        icon={<ExpandAltOutlined />}
                        onClick={() => setModalOpen(true)}
                    />
                    {chartConfig && <AgCharts options={chartConfig} />}
                </div>
                <Modal
                    centered
                    open={modalOpen}
                    onCancel={() => setModalOpen(false)}
                    footer={null}
                    width='90%'
                >
                    {chartConfig && <AgCharts options={chartConfig} style={{ height: '70vh' }} />}
                </Modal>
            </div>
        </Spin>
    );
}

export default OVMSUsageChart;
